

export class GpsDeviceWithStatusOutputData implements IGpsDeviceWithStatusOutputData {
    /** The auto-generated id of the gps device master */
    gps_device_id!: number;
    /** The branch name with 255 character */
    branch!: string;
    /** The company name with 255 character */
    company_name!: string;
    /** The vehicle with name and number */
    vehicle!: string;
    /** The vehicle type name with 255 character */
    vehicle_type_name!: string;
    /** The vehicle model name with 255 character */
    vehicle_model_name!: string;
    /** The vehicle icon */
    vehicle_icon!: string;
    /** The provider name with 255 character */
    provider_name!: string;
    /** The secondary sim provider name with 255 character */
    secondary_sim_provider!: string;
    /** The sim card number with 255 character */
    card_number!: string;
    /** The secondary sim card number with 255 character */
    secondary_sim_number!: string;
    /** The IMEI number with 500 character */
    imei_number!: string;
    /** The device name with 255 character" */
    device_model_name!: string;
    /** The GPS device name with 255 character" */
    gps_device_name!: string;
    /** The device brand name with 255 character" */
    device_brand_name!: string;
    /** The auto-generated creating time of tbl_vehicle_group item add */
    creating_date!: any;
    /** The expiry date should be with 10 character */
    installation_date!: string;
    /** The refresh intervale */
    refresh_interval!: number;
    /** The data intervale */
    data_interval!: number;
    /** The distance calculation */
    distance_calculation!: string;
    /** The speed calculation */
    speed_calculation!: string;
    /** The time zone */
    time_zone!: string;
    /** The allocated number of port to gps device */
    allocated_port_count!: number;
    /** Manage status of device. 0 For De-active, 1 For Active */
    status!: number;
    /** The tc device id */
    tc_device_id!: number;

    constructor(data?: IGpsDeviceWithStatusOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gps_device_id = _data["gps_device_id"];
            this.branch = _data["branch"];
            this.company_name = _data["company_name"];
            this.vehicle = _data["vehicle"];
            this.vehicle_type_name = _data["vehicle_type_name"];
            this.vehicle_model_name = _data["vehicle_model_name"];
            this.vehicle_icon = _data["vehicle_icon"];
            this.provider_name = _data["provider_name"];
            this.secondary_sim_provider = _data["Secondary_sim_provider"];
            this.card_number = _data["card_number"];
            this.secondary_sim_number = _data["Secondary_sim_number"];
            this.imei_number = _data["imei_number"];
            this.device_model_name = _data["device_model_name"];
            this.gps_device_name = _data["gps_device_name"];
            this.device_brand_name = _data["device_brand_name"];
            this.creating_date = _data["creating_date"];
            this.installation_date = _data["installation_date"];
            this.refresh_interval = _data["refresh_interval"];
            this.data_interval = _data["data_interval"];
            this.distance_calculation = _data["distance_calculation"];
            this.speed_calculation = _data["speed_calculation"];
            this.time_zone = _data["time_zone"];
            this.allocated_port_count = _data["allocated_port_count"];
            this.status = _data["status"];
            this.tc_device_id = _data["tc_device_id"];
        }
    }

    static fromJS(data: any): GpsDeviceWithStatusOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new GpsDeviceWithStatusOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gps_device_id"] = this.gps_device_id;
        data["branch"] = this.branch;
        data["company_name"] = this.company_name;
        data["vehicle"] = this.vehicle;
        data["vehicle_type_name"] = this.vehicle_type_name;
        data["vehicle_model_name"] = this.vehicle_model_name;
        data["vehicle_icon"] = this.vehicle_icon;
        data["provider_name"] = this.provider_name;
        data["Secondary_sim_provider"] = this.secondary_sim_provider;
        data["card_number"] = this.card_number;
        data["Secondary_sim_number"] = this.secondary_sim_number;
        data["imei_number"] = this.imei_number;
        data["device_model_name"] = this.device_model_name;
        data["gps_device_name"] = this.gps_device_name;
        data["device_brand_name"] = this.device_brand_name;
        data["creating_date"] = this.creating_date;
        data["installation_date"] = this.installation_date;
        data["refresh_interval"] = this.refresh_interval;
        data["data_interval"] = this.data_interval;
        data["distance_calculation"] = this.distance_calculation;
        data["speed_calculation"] = this.speed_calculation;
        data["time_zone"] = this.time_zone;
        data["allocated_port_count"] = this.allocated_port_count;
        data["status"] = this.status;
        data["tc_device_id"] = this.tc_device_id;
        return data; 
    }
}

export interface IGpsDeviceWithStatusOutputData {
    /** The auto-generated id of the gps device master */
    gps_device_id: number;
    /** The branch name with 255 character */
    branch: string;
    /** The company name with 255 character */
    company_name: string;
    /** The vehicle with name and number */
    vehicle: string;
    /** The vehicle type name with 255 character */
    vehicle_type_name: string;
    /** The vehicle model name with 255 character */
    vehicle_model_name: string;
    /** The vehicle icon */
    vehicle_icon: string;
    /** The provider name with 255 character */
    provider_name: string;
    /** The secondary sim provider name with 255 character */
    secondary_sim_provider: string;
    /** The sim card number with 255 character */
    card_number: string;
    /** The secondary sim card number with 255 character */
    secondary_sim_number: string;
    /** The IMEI number with 500 character */
    imei_number: string;
    /** The device name with 255 character" */
    device_model_name: string;
    /** The GPS device name with 255 character" */
    gps_device_name: string;
    /** The device brand name with 255 character" */
    device_brand_name: string;
    /** The auto-generated creating time of tbl_vehicle_group item add */
    creating_date: any;
    /** The expiry date should be with 10 character */
    installation_date: string;
    /** The refresh intervale */
    refresh_interval: number;
    /** The data intervale */
    data_interval: number;
    /** The distance calculation */
    distance_calculation: string;
    /** The speed calculation */
    speed_calculation: string;
    /** The time zone */
    time_zone: string;
    /** The allocated number of port to gps device */
    allocated_port_count: number;
    /** Manage status of device. 0 For De-active, 1 For Active */
    status: number;
    /** The tc device id */
    tc_device_id: number;
}

